import { create } from "zustand";

export const useAPIError = create((set, omit) => ({
    error: {},
    deleteError: () => set((state) => omit(state, ["error"]), true),
}));

export const setAPIError = (newError) => useAPIError.setState({ error: newError });
